/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./scroll-bubble.vue?vue&type=template&id=2c839b88&"
import script from "./scroll-bubble.vue?vue&type=script&lang=js&"
export * from "./scroll-bubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports